import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-back\">\n<path d=\"M104.4,62.5H103V29.9c0-12.2-6.9-17.3-15.5-10.3L7.9,84c-8.6,6.9-8.5,18.3,0,25.2l79,63.8c8.6,6.9,16.1-0.1,16.1-10.4v-34.4\n\th12c34.5,0,60.9,15,77,44c3.2,5.3,6.5,4.1,6.5,0C197.8,120.6,154.4,62.5,104.4,62.5L104.4,62.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol